<div class="fids-secondary-header">
  <header id="pageHeader" class="mdc-top-app-bar page-header-shadow" style="z-index: 0;">
    <div class="mdc-top-app-bar__row page-header-row">
      <div class=" mb-1 mt-2 page-header-text">
        <section class="mdc-top-app-bar__section mdc-top-app-bar__section--align-start pl-0 pt-0">
          <h6 class="mdc-typography--headline5 mb-0 ml--1" [matTooltip]="tooltip" matTooltipClass="ey-custom-tooltip"
            matTooltipPosition="below">
            {{header}}
          </h6>
        </section>
        <div class="header-para pl-0">
          <p class="mdc-typography--body2 mb-0" [innerHTML]="description">
          </p>
        </div>
      </div>
      <div class="ml-auto m-t-10">
        <ng-content select="[header-buttons]"></ng-content>
      </div>
    </div>
  </header>
  <div class="header-breadcrumb-row">
    @if(showBreadcrumb){
    <p-breadcrumb class="max-w-full" [model]="items"></p-breadcrumb>
    <ng-content select="[header-right]"></ng-content>
    }
  </div>
</div>